// import { men } from "../data/db.json";

import { Link, useParams } from "react-router-dom";
import axios from "axios";
import BeatLoader from "react-spinners/BeatLoader";
import { useState, useEffect } from "react";
import Navbar from "./Navbar";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const CategoryWise = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [all, setAll] = useState([]);
  const [filter, setFilter] = useState({});
  const [discountFilter, setDiscountFilter] = useState("0");
  const [isDiscountFilter, setIsDiscountFilter] = useState(false);
  const [isSortByDropdownOpen, setIsSortByDropdownOpen] = useState(false);
  const [sortBy, setSortBy] = useState("Recommended")
  const { category } = useParams();
  useEffect(() => {
    setLoading(true);
    axios.get(SERVER_URL + "/api/products").then((res) => {
      setTimeout(() => {
        console.log(res.data);
        setProducts((prev) => res.data);
        setAll((prev) => res.data);
        var filteredProducts = [];
        if (count > 0 || isDiscountFilter) {
          if (count > 0) {
            var filters = [];
            // eslint-disable-next-line array-callback-return
            Object.entries(filter).map((entry) => {
              let key = entry[0];
              let value = entry[1];
              if (value === true) filters.push(key);
            });
            console.log(filters);

            all.forEach((product) => {
              if (filters.includes((product.pCategory.cName).toLowerCase()) || filters.includes((product.pName).toLowerCase())) {
                filteredProducts.push(product);
              }
            });
          }
          if (isDiscountFilter) {
            if (count > 0)
              filteredProducts = filteredProducts.filter((product) => (parseInt(product.pOffer) >= parseInt(discountFilter)));
            else
              filteredProducts = all.filter((product) => (parseInt(product.pOffer) >= parseInt(discountFilter)));

          }
          console.log(filteredProducts, count);
          setProducts((prev) => filteredProducts);
        }

      }, 100);
      setLoading(false)
      // console.log(products);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, category, discountFilter]);

  const handleClickSort = (e) => {
    setIsSortByDropdownOpen((prev) => false);
    setSortBy(e.target.name);
    console.log(isSortByDropdownOpen);
  }


  const Sidebar = () => {
    // const changefilter = (id) => {
    //   let selected = filter.selected;
    //   let find = selected.indexOf(id);

    //   if (find > -1) {
    //     selected.splice(find, 1);
    //   } else {
    //     selected.push(id);
    //   }

    //   setFilter({ selected });
    // };

    console.log(filter);

    const handleChange = (event) => {
      var change = event.target.checked ? 1 : -1;
      setCount((prev) => prev + change);
      setFilter({ ...filter, [event.target.name]: event.target.checked });
    };

    const handleDiscountFilter = (event) => {
      if (event.target.checked) {
        setIsDiscountFilter(true);
        setDiscountFilter(event.target.name);
      }
      else {
        setIsDiscountFilter(false);
        setDiscountFilter("");
      }
    };



    return (
      <div className="sidebar sidebar-desktop" style={{ width: "15%", minWidth: "230px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "5px 25px 15px",
            textTransform: "uppercase",
            // fontWeight: "600",
          }}
        >
          <div style={{ fontWeight: "600", letterSpacing: "0.3px" }}>Filters</div>
          <div
            style={{ color: "#00BCF2", cursor: "pointer", fontSize: "0.8rem", fontWeight: "500", letterSpacing: "0.3px" }}
            onClick={() => {
              setCount(0);
              setFilter({});
              setIsDiscountFilter(false);
              setDiscountFilter("0");
            }}
          >
            Clear All
          </div>
        </div>{" "}
        <div className="category-filter-div" style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
              fontSize: "14px",
              letterSpacing: "0.05px"
            }}
          >
            categories
          </div>
          <ul>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="tshirts"
                  checked={filter["tshirts"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Tshirts</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="shirts"
                  checked={filter["shirts"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Shirts</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="shorts"
                  checked={filter["shorts"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Shorts</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="shoes"
                  checked={filter["shoes"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Shoes</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="kurtas"
                  checked={filter["kurtas"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span>Kurtas</span>
              </label>
            </li>
          </ul>
        </div>
        <div className="category-filter-div" style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
              fontSize: "14px",
              letterSpacing: "0.05px"
            }}
          >
            Brand
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox"
                  name="red tape"
                  checked={filter["red tape"]}
                  onChange={(e) => handleChange(e)}
                /> Red Tape
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="nike"
                  checked={filter["nike"]}
                  onChange={(e) => handleChange(e)}
                /> Nike
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="adidas"
                  checked={filter["adidas"]}
                  onChange={(e) => handleChange(e)}
                /> Adidas
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox"
                  name="hrx"
                  checked={filter["hrx"]}
                  onChange={(e) => handleChange(e)}
                /> HRX by Hrithik Roshan
              </label>
            </li>
            <li>
              <label>

                <input type="checkbox"
                  name="calvin klein"
                  checked={filter["calvin klein"]}
                  onChange={(e) => handleChange(e)}
                /> Calvin Klein
              </label>
            </li>
          </ul>
        </div>
        <div className="category-filter-div" style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
              fontSize: "14px",
              letterSpacing: "0.05px"
            }}
          >
            color
          </div>
          <ul>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="black"
                  checked={filter["black"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span dataColorhex="black" className="colour-label colour-colorDisplay" style={{ backgroundColor: "rgb(54, 69, 79)" }}></span>

                <span>Black</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="green"
                  checked={filter["green"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span dataColorhex="green" className="colour-label colour-colorDisplay" style={{ backgroundColor: "rgb(94, 177, 96)" }}></span>

                <span>Green</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="blue"
                  checked={filter["blue"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span dataColorhex="blue" className="colour-label colour-colorDisplay" style={{ backgroundColor: "rgb(0,116,217)" }}></span>
                <span>Blue</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="white"
                  checked={filter["white"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span dataColorhex="white" className="colour-label colour-colorDisplay" style={{ backgroundColor: "#fff" }}></span>

                <span>White</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  name="red"
                  checked={filter["red"]}
                  onChange={(e) => handleChange(e)}
                />{" "}
                <span dataColorhex="red" className="colour-label colour-colorDisplay" style={{ backgroundColor: "rgb(211, 75, 86)" }}></span>
                <span>Red</span>
              </label>
            </li>
          </ul>
        </div>
        {/* <div className="category-filter-div" style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
              fontSize: "14px",
              letterSpacing: "0.05px"
            }}
          >
            Price
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" /> Rs. 199 to Rs. 1149
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 1149 to Rs. 2099
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 2099 to Rs. 3049
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 3049 to Rs. 3999
              </label>
            </li>
          </ul>
        </div> */}
        <div className="category-filter-div" style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
              fontSize: "14px",
              letterSpacing: "0.05px"
            }}
          >
            Discount Range
          </div>
          <ul>
            <li>
              <label>
                <input type="radio"
                  name="10"
                  checked={discountFilter === "10"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 10% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="20"
                  checked={discountFilter === "20"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 20% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="30"
                  checked={discountFilter === "30"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 30% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="40"
                  checked={discountFilter === "40"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 40% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="50"
                  checked={discountFilter === "50"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 50% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="60"
                  checked={discountFilter === "60"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 60% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="70"
                  checked={discountFilter === "70"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 70% and above
              </label>
            </li>
            <li>
              <label>
                <input type="radio"
                  name="80"
                  checked={discountFilter === "80"}
                  onChange={(e) => handleDiscountFilter(e)}
                /> 80% and above
              </label>
            </li>
          </ul>
        </div>
      </div>
    );
  };


  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "black",
  };


  return (
    <>
      <Navbar />
      <div className="men">
        <div className="categorywise-container" style={{ display: "flex" }}>
          <Sidebar></Sidebar>
          {loading ?
            <div className="main-Content-1" style={{ width: "85%", marginTop: "10%" }}>
              <BeatLoader
                color="#00bcf2"
                loading={loading}
                cssOverride={override}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
            : <>
              <div style={{ width: "85%", display: "flex", flexDirection: "column" }}>
                {/* For selected filter list */}
                {/* <div>
                  <ul class="filter-summary-filterList">
                    <li>
                      <div class="filter-summary-filter">
                        Roadster
                        <label class="filter-summary-removeFilter">
                          <span class="myntraweb-sprite filter-summary-removeIcon sprites-remove">
                            x
                          </span>
                        </label>
                      </div>
                    </li>
                  </ul>
                </div> */}
                <div className="sort-sortBy">
                  <span onClick={() => setIsSortByDropdownOpen(true)}>
                    {"Sort by : "}
                    <span style={{ fontWeight: "600" }}>{sortBy}</span>
                    <span class="sort-downArrow"></span>
                  </span>
                  {isSortByDropdownOpen &&
                    <ul class="sort-list" style={{ zIndex: "10000" }}>
                      <li>
                        <label class="sort-label ">
                          <input type="radio" value="recommended" name="Recommended"
                            onClick={
                              (e) =>
                                handleClickSort(e)
                            }
                          />
                          Recommended
                        </label>
                      </li>
                      <li>
                        <label class="sort-label ">
                          <input type="radio" value="pl" name="Price : Low to High"
                            onClick={
                              (e) =>
                                handleClickSort(e)
                            }
                          />
                          Price : Low to High
                        </label>
                      </li>
                      <li>
                        <label class="sort-label ">
                          <input type="radio" value="ph" name="Price : High to Low"
                            onClick={
                              (e) =>
                                handleClickSort(e)
                            } />
                          Price : High to Low
                        </label>
                      </li>
                    </ul>
                  }
                </div>


                <div className="main-Content-1" style={{ width: "95%" }}>

                  {products &&
                    products
                      .filter(function (product) {
                        return (product.pType).toLowerCase() === category;
                      })
                      .map((product) => (
                        <div className="inner CC">
                          <div class="productRatingsContainer">
                            <span>4.7</span>
                            <span class="myntraweb-sprite starIcon index-productRatingsGoodIcon RatingsGoodIcon"></span>
                            <div class="ratingsCount">
                              <div class="separator">|</div>15.7k
                            </div>
                          </div>
                          <Link
                            to={`/product/${product._id}`}
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            <div className="content">
                              <img
                                src={SERVER_URL + `/uploads/products/${product.pImages[0]}`}
                                className="card-img-top"
                                alt="..."
                              />
                              <div className="card-body">
                                <h6
                                  className="card-title"
                                  title={`${product.pName}`}
                                  style={{ textAlign: "start", marginBottom: "5px" }}
                                >
                                  {product.pName}
                                </h6>
                                <p className="brand-name">{product.pDescription}</p>
                                <h6 className="brand-name">
                                  <span>
                                    <strong>₹{Math.floor(product.pPrice * (100 - product.pOffer) / 100)}</strong>
                                  </span>
                                  <span style={{ fontWeight: 400, marginLeft: "8px", fontSize: "12px", opacity: "0.8", lineHeight: 1.2 }}>
                                    <s>Rs.{product.pPrice}</s>
                                  </span>
                                  <span style={{
                                    fontWeight: 500, marginLeft: "8px", fontSize: "12px",
                                    letterSpacing: ".5px",
                                    color: "#ff905a"
                                  }}>
                                    ({product.pOffer}% OFF)
                                  </span>
                                </h6>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                </div>
              </div>

            </>
          }
        </div>
      </div>
    </>
  );
};

export default CategoryWise;
